import { ApiError } from '@melio/api-client/src/core/types';
import { AuthApiClient, PostSendEmailVerificationCodeRequest } from '@melio/platform-api-axios-client';
// eslint-disable-next-line no-restricted-imports
import { useMutation } from 'react-query';

export const useAuthSendEmailVerification = () => {
  const { mutateAsync: sendMutateAsync, ...rest } = useMutation<
    unknown,
    ApiError,
    PostSendEmailVerificationCodeRequest
  >(({ email, partnerName, melioOnly }: PostSendEmailVerificationCodeRequest) =>
    AuthApiClient.postAuthSendEmailValidationCode({
      email,
      partnerName,
      melioOnly,
    })
  );
  return {
    sendVerificationCode: sendMutateAsync,
    ...rest,
  };
};
